export default __webpack_public_path__ + "static/media/location.3aff3b77.svg";